"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editDistributionStandby = exports.editDistributionFailed = exports.editDistributionSuccess = exports.editDistributionRequest = exports.createNewDistributionFailed = exports.createNewDistributionSuccess = exports.createNewDistributionRequest = exports.clearWizard = exports.changeDistributionRecipientPrintProvider = exports.changeDistributionRecipientDeliveryMethod = exports.changeDistributionRecipientFinishing = exports.changeDistributionRecipientQuantity = exports.removeDistributionRecipient = exports.addDistributionRecipient = exports.changeDescription = exports.changeName = exports.changeStep2AddNewDeliveryAddress = exports.changeStep2Tab = exports.changeStep2Display = exports.validateStepSuccess = exports.validateStepFailure = exports.changeStep = exports.openEditMenu = exports.openCreateMenu = exports.closeMenu = void 0;
const Actions = require("../../actionTypes/distribution/wizard");
const closeMenu = () => ({
    type: Actions.CLOSE_MENU
});
exports.closeMenu = closeMenu;
const openCreateMenu = () => ({
    type: Actions.OPEN_CREATE_MENU
});
exports.openCreateMenu = openCreateMenu;
const openEditMenu = (distribution) => ({
    type: Actions.OPEN_EDIT_MENU,
    payload: {
        distribution
    }
});
exports.openEditMenu = openEditMenu;
const changeStep = (wizardStep) => ({
    type: Actions.CHANGE_STEP,
    payload: {
        wizardStep
    }
});
exports.changeStep = changeStep;
const validateStepFailure = (errors) => ({
    type: Actions.VALIDATE_STEP_FAILURE,
    payload: {
        errors
    }
});
exports.validateStepFailure = validateStepFailure;
const validateStepSuccess = (wizardStep) => ({
    type: Actions.VALIDATE_STEP_SUCCESS,
    payload: {
        wizardStep
    }
});
exports.validateStepSuccess = validateStepSuccess;
const changeStep2Display = (display) => ({
    type: Actions.CHANGE_STEP2_DISPLAY,
    payload: {
        display
    }
});
exports.changeStep2Display = changeStep2Display;
const changeStep2Tab = (tab) => ({
    type: Actions.CHANGE_STEP2_TAB,
    payload: {
        tab
    }
});
exports.changeStep2Tab = changeStep2Tab;
const changeStep2AddNewDeliveryAddress = (status) => ({
    type: Actions.CHANGE_STEP2_ADD_NEW_DELIVERY_ADDRESS,
    payload: {
        status
    }
});
exports.changeStep2AddNewDeliveryAddress = changeStep2AddNewDeliveryAddress;
const changeName = (name) => ({
    type: Actions.CHANGE_NAME,
    payload: {
        name
    }
});
exports.changeName = changeName;
const changeDescription = (description) => ({
    type: Actions.CHANGE_DESCRIPTION,
    payload: {
        description
    }
});
exports.changeDescription = changeDescription;
const addDistributionRecipient = (recipients) => ({
    type: Actions.ADD_DISTRIBUTION_RECIPIENT,
    payload: {
        recipients
    }
});
exports.addDistributionRecipient = addDistributionRecipient;
const removeDistributionRecipient = (uuid) => ({
    type: Actions.REMOVE_DISTRIBUTION_RECIPIENT,
    payload: {
        uuid
    }
});
exports.removeDistributionRecipient = removeDistributionRecipient;
const changeDistributionRecipientQuantity = (uuid, quantity) => ({
    type: Actions.CHANGE_DISTRIBUTION_RECIPIENT_QUANTITY,
    payload: {
        uuid,
        quantity
    }
});
exports.changeDistributionRecipientQuantity = changeDistributionRecipientQuantity;
const changeDistributionRecipientFinishing = (uuid, finishing) => ({
    type: Actions.CHANGE_DISTRIBUTION_RECIPIENT_FINISHING,
    payload: {
        uuid,
        finishing
    }
});
exports.changeDistributionRecipientFinishing = changeDistributionRecipientFinishing;
const changeDistributionRecipientDeliveryMethod = (uuid, deliveryMethod) => ({
    type: Actions.CHANGE_DISTRIBUTION_RECIPIENT_DELIVERY_METHOD,
    payload: {
        uuid,
        deliveryMethod
    }
});
exports.changeDistributionRecipientDeliveryMethod = changeDistributionRecipientDeliveryMethod;
const changeDistributionRecipientPrintProvider = (uuid, printProvider) => ({
    type: Actions.CHANGE_DISTRIBUTION_RECIPIENT_PRINT_PROVIDER,
    payload: {
        uuid,
        printProvider
    }
});
exports.changeDistributionRecipientPrintProvider = changeDistributionRecipientPrintProvider;
const clearWizard = () => ({
    type: Actions.CLEAR_WIZARD
});
exports.clearWizard = clearWizard;
const createNewDistributionRequest = (project, name, description, recipients) => ({
    type: Actions.CREATE_NEW_DISTRIBUTION_REQUEST,
    payload: {
        project,
        name,
        description,
        recipients
    }
});
exports.createNewDistributionRequest = createNewDistributionRequest;
const createNewDistributionSuccess = (payload) => ({
    type: Actions.CREATE_NEW_DISTRIBUTION_SUCCESS,
    payload
});
exports.createNewDistributionSuccess = createNewDistributionSuccess;
const createNewDistributionFailed = (error) => ({
    type: Actions.CREATE_NEW_DISTRIBUTION_FAILED,
    payload: error
});
exports.createNewDistributionFailed = createNewDistributionFailed;
const editDistributionRequest = (id, project, name, description, recipients) => ({
    type: Actions.EDIT_DISTRIBUTION_REQUEST,
    payload: {
        id,
        project,
        name,
        description,
        recipients
    }
});
exports.editDistributionRequest = editDistributionRequest;
const editDistributionSuccess = (payload) => ({
    type: Actions.EDIT_DISTRIBUTION_SUCCESS,
    payload
});
exports.editDistributionSuccess = editDistributionSuccess;
const editDistributionFailed = (error) => ({
    type: Actions.EDIT_DISTRIBUTION_FAILED,
    payload: error
});
exports.editDistributionFailed = editDistributionFailed;
const editDistributionStandby = () => ({
    type: Actions.EDIT_DISTRIBUTION_STANDBY
});
exports.editDistributionStandby = editDistributionStandby;
//# sourceMappingURL=wizard.js.map